import { useMemo } from 'react';

import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';

import type { TBankOffers } from '../../../types/bank-offer.types';

interface IProps {
  bankOffer: TBankOffers;
  offerDetailsModal: boolean | string;
}

const useAdditionalHelpers = ({ bankOffer, offerDetailsModal }: IProps) => {
  const additionalProducts = useMemo(() => {
    const products = {
      title: 'Доп. продукты',
      content: [] as string[]
    };

    products.content.push('КАСКО в подарок');

    return products;
  }, []);

  const getDescription = () => {
    const description = bankOffer.bankDescription || '';
    const isValidJSON = checkIsValidJSON(description);
    const parsedJSON =
      isValidJSON && JSON.stringify(JSON.parse(description), null, 2);

    return typeof offerDetailsModal === 'string'
      ? offerDetailsModal
      : parsedJSON || description;
  };

  return { additionalProducts, getDescription };
};

export default useAdditionalHelpers;
